/**
 * Configuración de idioma español para PrimeNG.
 * Basado en el locale oficial de PrimeLocale: https://github.com/primefaces/primelocale
 * Se pasa como segundo argumento a providePrimeNG() en app.config.ts.
 */
export const configLanguage = {
  translation: {
    // Filtros
    startsWith: 'Empieza con',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina con',
    equals: 'Igual a',
    notEquals: 'Distinto de',
    noFilter: 'Sin filtro',
    filter: 'Filtrar',
    lt: 'Menor que',
    lte: 'Menor o igual que',
    gt: 'Mayor que',
    gte: 'Mayor o igual que',
    matchAll: 'Coincidir con todos',
    matchAny: 'Coincidir con cualquiera',
    addRule: 'Agregar regla',
    removeRule: 'Eliminar regla',
    custom: 'Personalizar',

    // Fechas
    dateIs: 'La fecha es',
    dateIsNot: 'La fecha no es',
    dateBefore: 'La fecha es anterior a',
    dateAfter: 'La fecha es posterior a',
    dateFormat: 'dd/mm/yy',
    firstDayOfWeek: 1,
    showMonthAfterYear: false,
    today: 'Hoy',
    now: 'Ahora',
    weekHeader: 'Sem',
    chooseDate: 'Elegir fecha',
    chooseMonth: 'Elegir mes',
    chooseYear: 'Elegir año',
    prevDecade: 'Década anterior',
    nextDecade: 'Próxima década',
    prevYear: 'Año anterior',
    nextYear: 'Próximo año',
    prevMonth: 'Mes anterior',
    nextMonth: 'Próximo mes',
    prevHour: 'Hora anterior',
    nextHour: 'Próxima hora',
    prevMinute: 'Minuto anterior',
    nextMinute: 'Siguiente minuto',
    prevSecond: 'Segundo anterior',
    nextSecond: 'Siguiente segundo',
    am: 'AM',
    pm: 'PM',
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
    ],
    monthNamesShort: [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
    ],

    // Acciones generales
    accept: 'Sí',
    reject: 'No',
    choose: 'Elegir',
    upload: 'Subir',
    cancel: 'Cancelar',
    clear: 'Limpiar',
    apply: 'Aplicar',
    pending: 'Pendiente',
    completed: 'Terminado',

    // Mensajes vacíos / búsqueda
    emptyMessage: 'No se han encontrado resultados',
    emptyFilterMessage: 'Sin opciones disponibles',
    emptySearchMessage: 'Sin opciones disponibles',
    emptySelectionMessage: 'Ningún elemento seleccionado',
    searchMessage: '{0} resultados disponibles',
    selectionMessage: '{0} elementos seleccionados',

    // Archivos
    choose_file: 'Elegir archivo',
    fileChosenMessage: '{0} archivos',
    noFileChosenMessage: 'No se ha elegido ningún archivo',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],

    // Contraseña
    weak: 'Débil',
    medium: 'Media',
    strong: 'Fuerte',
    passwordPrompt: 'Ingrese una contraseña',

    // Aria labels (accesibilidad)
    aria: {
      cancelEdit: 'Cancelar edición',
      close: 'Cerrar',
      collapseLabel: 'Contraer',
      collapseRow: 'Contraer fila',
      editRow: 'Editar fila',
      expandLabel: 'Expandir',
      expandRow: 'Expandir fila',
      falseLabel: 'Falso',
      filterConstraint: 'Restricción de filtro',
      filterOperator: 'Operador de filtro',
      firstPageLabel: 'Primera página',
      gridView: 'Vista de cuadrícula',
      hideFilterMenu: 'Ocultar menú de filtro',
      jumpToPageDropdownLabel: 'Ir a página',
      jumpToPageInputLabel: 'Ir a página',
      lastPageLabel: 'Última página',
      listLabel: 'Lista de opciones',
      listView: 'Vista de lista',
      maximizeLabel: 'Maximizar',
      minimizeLabel: 'Minimizar',
      moveAllToSource: 'Mover todo al origen',
      moveAllToTarget: 'Mover todo al destino',
      moveBottom: 'Mover al final',
      moveDown: 'Bajar',
      moveTop: 'Mover al inicio',
      moveToSource: 'Mover al origen',
      moveToTarget: 'Mover al destino',
      moveUp: 'Subir',
      navigation: 'Navegación',
      next: 'Siguiente',
      nextPageLabel: 'Página siguiente',
      nullLabel: 'No seleccionado',
      otpLabel: 'Ingrese el carácter {0} de la contraseña de un solo uso',
      pageLabel: 'Página {page}',
      passwordHide: 'Ocultar contraseña',
      passwordShow: 'Mostrar contraseña',
      previous: 'Anterior',
      prevPageLabel: 'Página anterior',
      removeLabel: 'Eliminar',
      rotateLeft: 'Girar a la izquierda',
      rotateRight: 'Girar a la derecha',
      rowsPerPageLabel: 'Filas por página',
      saveEdit: 'Guardar edición',
      scrollTop: 'Ir al inicio',
      selectAll: 'Seleccionar todos',
      selectColor: 'Seleccionar color',
      selectLabel: 'Seleccionar',
      selectRow: 'Seleccionar fila',
      showFilterMenu: 'Mostrar menú de filtro',
      slide: 'Deslizar',
      slideNumber: '{slideNumber}',
      star: '1 estrella',
      stars: '{star} estrellas',
      trueLabel: 'Verdadero',
      unselectAll: 'Deseleccionar todos',
      unselectLabel: 'Deseleccionar',
      unselectRow: 'Deseleccionar fila',
      zoomImage: 'Ampliar imagen',
      zoomIn: 'Ampliar',
      zoomOut: 'Reducir',
    },
  },
};
